var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 33.5,
    fill: "white",
    stroke: "#A52700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2733 44.7058C51.4673 44.7058 49.9022 44.3654 48.5778 43.6847C47.2735 43.004 46.2702 42.0431 45.5679 40.8018C44.8656 39.5405 44.5144 38.049 44.5144 36.3272H49.3604C49.3604 37.128 49.5209 37.8188 49.842 38.3993C50.163 38.9799 50.6145 39.4304 51.1964 39.7507C51.7984 40.071 52.5108 40.2312 53.3335 40.2312C54.1361 40.2312 54.8384 40.071 55.4404 39.7507C56.0424 39.4304 56.5039 38.9799 56.825 38.3993C57.146 37.8188 57.3066 37.128 57.3066 36.3272H62.1525C62.1525 38.049 61.7913 39.5405 61.069 40.8018C60.3666 42.0431 59.3433 43.004 57.9988 43.6847C56.6745 44.3654 55.0993 44.7058 53.2733 44.7058ZM44.5144 36.3272V23.2939H49.3604V36.3272H44.5144ZM57.3066 36.3272V23.2939H62.1525V36.3272H57.3066Z",
    fill: "url(#paint0_linear_733_10407)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.477 44.7058C34.4692 44.7058 33.5009 44.5776 32.5721 44.3213C31.6631 44.0453 30.8331 43.6805 30.0822 43.2271C29.351 42.7539 28.7483 42.2314 28.274 41.6596C27.7998 41.0681 27.5033 40.4372 27.3848 39.7669L32.0978 38.436C32.3152 39.0078 32.6907 39.5105 33.2242 39.9443C33.7775 40.3583 34.4692 40.5752 35.2991 40.5949C36.1094 40.6147 36.7812 40.4273 37.3148 40.033C37.8681 39.6387 38.1448 39.1261 38.1448 38.4952C38.1448 38.0023 37.9472 37.5685 37.5519 37.1939C37.1765 36.8193 36.633 36.5334 35.9216 36.3362L32.9871 35.5969C31.9595 35.3406 31.0604 34.9364 30.2897 34.3843C29.5387 33.8323 28.9459 33.1619 28.5112 32.3733C28.0962 31.5649 27.8887 30.6481 27.8887 29.6229C27.8887 27.6315 28.5507 26.0838 29.8747 24.9797C31.1987 23.8559 33.0661 23.2939 35.477 23.2939C36.801 23.2939 37.957 23.4812 38.9451 23.8559C39.9332 24.2107 40.773 24.7431 41.4647 25.4529C42.1761 26.1627 42.7393 27.0499 43.1542 28.1146L38.4708 29.5046C38.3127 28.9722 37.9669 28.4892 37.4334 28.0554C36.9196 27.6217 36.2477 27.4048 35.4177 27.4048C34.5877 27.4048 33.9356 27.5921 33.4613 27.9667C33.0068 28.3413 32.7796 28.8835 32.7796 29.5933C32.7796 30.0862 32.9673 30.5002 33.3428 30.8354C33.7182 31.1509 34.232 31.3875 34.8842 31.5452L37.8187 32.2845C39.4984 32.6986 40.8027 33.4774 41.7314 34.6209C42.68 35.7447 43.1542 37.0263 43.1542 38.4656C43.1542 39.7669 42.8479 40.8808 42.2353 41.8075C41.6425 42.7341 40.773 43.4538 39.6269 43.9664C38.4807 44.4593 37.0974 44.7058 35.477 44.7058Z",
    fill: "url(#paint1_linear_733_10407)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8187 44.7059L22.6366 23.2939H27.9711L19.6014 44.7059H14.8187ZM14.2669 44.7059L5.86646 23.2939H11.1704L19.0496 44.7059H14.2669Z",
    fill: "url(#paint2_linear_733_10407)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_733_10407",
    x1: 57.3152,
    y1: 45.334,
    x2: 65.4689,
    y2: 23.2939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAC48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_733_10407",
    x1: 29.6877,
    y1: 25.2796,
    x2: 43.1542,
    y2: 44.7059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883297,
    stopColor: "#ECAC48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_733_10407",
    x1: -3.82347,
    y1: 23.2939,
    x2: 20.4301,
    y2: 44.7608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A52700"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.67ddbdb16c6d83c59272f1c0d99eeee9.svg";
export { ForwardRef as ReactComponent };